import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import * as _moment from 'moment';
import { map } from 'rxjs/operators';
import { FantasyHistory, FantasyHistoryQuery } from '@fgb/core';
const moment = _moment;

@Component({
  selector: 'fgb-fantasy-game-results',
  templateUrl: './fantasy-game-results.component.html',
  styleUrl: './fantasy-game-results.component.scss',
})
export class FantasyGameResultsComponent implements OnInit {
  fantasyHistory$: Observable<FantasyHistory[]>;
  pendingPeriod: number = 0;

  constructor(private fantasyHistoryQuery: FantasyHistoryQuery) { }

  ngOnInit() {
    this.fantasyHistory$ = this.fantasyHistoryQuery
      .selectHistoryBeforeDate(moment.utc().subtract(this.pendingPeriod, 'hours'))
      .pipe(map((x) => (x = x.slice(0, 8))));
  }
}
